module.exports = __webpack_public_path__ + "img/logo-stegi-radio.df0f9e09.png";